import { MenuItem } from '@mui/material'
import { Field, useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import { CustomTextField } from 'src/form'
import { FollowUpProgram } from 'src/graphql.generated'

type Props = {
  followUpProgram: FollowUpProgram
  terminateProgram: boolean
}

const FollowUpProgramSelect = ({ followUpProgram, terminateProgram }: Props) => {
  const { setFieldValue } = useFormikContext<{ followUpProgramID: string | undefined }>()

  useEffect(() => {
    if (!terminateProgram) {
      setFieldValue('followUpProgramID', followUpProgram.programID ?? undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [followUpProgram.programID, terminateProgram])

  return (
    <Field
      component={CustomTextField}
      fullWidth
      label="Follow-up program"
      name="followUpProgramID"
      type="select"
      unregisterOnUnmount={false}
    >
      <MenuItem value="">-</MenuItem>
      {followUpProgram.programOptions.map((program) => (
        <MenuItem key={program} value={program}>
          {program}
        </MenuItem>
      ))}
    </Field>
  )
}

export default FollowUpProgramSelect
